import { API } from 'shared/utils/apiMiddleware';
import { BILLINGS_API_NAME, COST_CENTERS_ROOT } from './helperFunctions';


export const fetchCostCenters = async () => API.get('billings', `${COST_CENTERS_ROOT}/data-access/list`);

export async function fetchManagementCostCenters() {
  return API.get(BILLINGS_API_NAME, `${COST_CENTERS_ROOT}/management/list`);
}

export async function fetchManagementCostCenterUnassignedAccounts(costCenterId) {
  if (costCenterId) {
    return API.get(
      BILLINGS_API_NAME,
      `${COST_CENTERS_ROOT}/management/${costCenterId}/accounts/unassigned`,
    );
  }
  return API.get(BILLINGS_API_NAME, `${COST_CENTERS_ROOT}/management/accounts/unassigned`);
}

export async function fetchManagementCostCenterAccounts(costCenterId) {
  return API.get(BILLINGS_API_NAME, `${COST_CENTERS_ROOT}/management/${costCenterId}/accounts`);
}

export async function createCostCenter({ costCenter, accountsPayload }) {
  const payload = {
    body: { costCenter, accountsPayload },
  };
  return API.post(BILLINGS_API_NAME, `${COST_CENTERS_ROOT}/management`, payload);
}

export async function updateDataAccessCostCenter({ costCenterId, costCenterAccountsData }) {
  const payload = {
    body: { costCenterAccountsData },
  };
  const encodedCostCenterId = encodeURIComponent(costCenterId);
  return API.put(
    BILLINGS_API_NAME,
    `${COST_CENTERS_ROOT}/management/${encodedCostCenterId}`,
    payload,
  );
}

export async function deleteDataAccessCostCenter(costCenterId) {
  const encodedCostCenterId = encodeURIComponent(costCenterId);
  return API.del(BILLINGS_API_NAME, `${COST_CENTERS_ROOT}/management/${encodedCostCenterId}`);
}
